/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';

const Divider = () => {
    return <div className='trackingListDivider'>&#8203;</div>;
}

export default Divider;
